// extracted by mini-css-extract-plugin
export var container = "_8c-0";
export var error = "_8c-9";
export var label = "_8c-5";
export var light = "_8c-6";
export var md = "_8c-3";
export var sm = "_8c-2";
export var thin = "_8c-8";
export var thinBold = "_8c-7";
export var vertical = "_8c-4";
export var xs = "_8c-1";